module.exports = __webpack_public_path__ + "img/Logo.73f6a9bc.png";